import React, { useState } from 'react'
import SidebarProjectsRecent from 'components/Sidebars/SidebarProjectsRecent'
import Layout from 'components/Layout'
import Projects from './components/Projects/Projects'
import useMediaQuery from 'hooks/useMediaQuery'
import * as _ from 'styles/helpers'

const Projects_Index = () => {
	const isMobile = useMediaQuery(_.MQ.before_nav)
	const [cardDisplay, setCardDisplay] = useState(true)

	// Force card display on mobile
	const effectiveCardDisplay = isMobile ? true : cardDisplay

	return (
		<Layout>
			<Layout.Page>
				<Layout.Sidebar>
					<SidebarProjectsRecent />
				</Layout.Sidebar>
				<Layout.Body>
					<Layout.PageHeader>
						<h2>Projects</h2>
					</Layout.PageHeader>
					<Projects
						cardDisplay={effectiveCardDisplay}
						onToggleCardDisplay={() => setCardDisplay(!cardDisplay)}
						isMobile={isMobile}
					/>
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default Projects_Index
